import { Box, CircularProgress } from "@mui/material";
import React from "react";

export default function Loader({
  sx = {
    width: "calc(100% - 10px)",
    height: "100%",
    margin: "auto",
  },
}) {
  return (
    <Box sx={sx}>
      <CircularProgress />
    </Box>
  );
}
